import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var Plus = function Plus() {
  return /*#__PURE__*/_jsxs("svg", {
    "aria-hidden": "true",
    role: "presentation",
    children: [/*#__PURE__*/_jsx("title", {
      children: "Plus Symbol Icon"
    }), /*#__PURE__*/_jsx("use", {
      href: "#icon-plus"
    })]
  });
};

export default Plus;